import styled from 'styled-components';
import { detailsBackground, outlineGray } from '../../config/colors';

export const DescriptionWrapper = styled.div`
  background-color: ${detailsBackground};
  padding: 20px 15px;
  margin-top: 5px;
  margin-bottom: 20px;
  height: 410px;
  width: 60%;
  border-radius: 3px;
`;

export const DescriptionText = styled.textarea`
  font-size: 0.875rem;
  font-family: Verdana, Arial, Helvetica, sans-serif;
  width: 100%;
  height: 120px;
  resize: none;
  border: 2px solid ${outlineGray};
  padding: 10px 10px;
`;
